import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CompanyIndividualContactsVue = _resolveComponent("CompanyIndividualContactsVue");
    const _component_b_tab = _resolveComponent("b-tab");
    const _component_CompanyGroupContactsVue = _resolveComponent("CompanyGroupContactsVue");
    const _component_b_tabs = _resolveComponent("b-tabs");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_b_tabs, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.activeTab) = $event)),
                    "nav-wrapper-class": "x_title tabs",
                    "content-class": "x_content"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_b_tab, {
                            key: "individual",
                            title: "Individual"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_CompanyIndividualContactsVue, {
                                    companyId: _ctx.companyId,
                                    onContactsUpdated: _ctx.onContactsUpdated
                                }, null, 8 /* PROPS */, ["companyId", "onContactsUpdated"])
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createVNode(_component_b_tab, {
                            key: "groups",
                            title: "Groups"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_CompanyGroupContactsVue, { companyId: _ctx.companyId }, null, 8 /* PROPS */, ["companyId"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ])
    ]));
}
